import { useTheme } from "@emotion/react";
import { Box, CardContent, Tooltip, Typography } from "@mui/material";
import useStyles from "./styles";
function prepareChartData(data, property) {
  if (!data || data?.length === 0) return [];

  const total = data?.reduce(
    (sum, item) => sum + (item?.atendimentosCount || 0),
    0
  );

  return data?.map((item) => {
    const value = item?.atendimentosCount || 0;
    return {
      name: item[property] || "Indefinido",
      value,
      posicao: item?.posicao,
      total: total,
      percent: total > 0 ? ((value / total) * 100)?.toFixed(1) : "0.0",
    };
  });
}

export default function StackedBarChart({
  data,
  property,
  colors = [],
  titulo,
  heightBar = 20,
  setSelectEtapa = () => {},
  selectEtapaFluxo = {},
  toggleDrawer = () => {},
  windowWidth = null,
  isPropertyColor = false,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const chartData = prepareChartData(data, property);

  return (
    <CardContent>
      {titulo && (
        <Box sx={styles.containerTitle}>
          <Typography sx={styles.titleComponent}>{titulo}</Typography>
        </Box>
      )}

      {/* Barra principal */}
      <Box sx={{ ...styles.containerComponente, height: heightBar }}>
        {chartData?.map((item, index) => (
          <Tooltip
            key={item?.posicao}
            title={
              <Box>
                <Typography sx={styles.titleTooltip}>{item?.name}</Typography>
                <Typography sx={styles.countTooltip}>
                  {item?.value} atendimento{item?.value > 1 ? "s" : ""} (
                  {item?.percent}%)
                </Typography>
              </Box>
            }
            arrow
          >
            <Box
              onClick={() => {
                setSelectEtapa(item);
                if (windowWidth < 750) {
                  toggleDrawer(true);
                }
              }}
              sx={{
                ...styles.boxGraph,
                flex: `${item?.value}`,
                minWidth: `${item.value > 0 ? "20px" : "0px"}`,
                backgroundColor: !isPropertyColor
                  ? theme.palette.colors[colors[item?.posicao % colors?.length]]
                      .medium
                  : colors[item?.posicao % colors?.length],
                ...(selectEtapaFluxo?.posicao === item?.posicao && {
                  transform: "translateY(-2px)",
                  boxShadow: "0px 6px 12px rgba(0,0,0,0.35)",
                  borderRadius: 2,
                  zIndex: 3,
                }),
              }}
            />
          </Tooltip>
        ))}
      </Box>
    </CardContent>
  );
}
